<template>
    <div>
      <b-modal
        ref="modalExportarFluxoDeCaixa"
        size="md"
        no-close-on-esc
        no-close-on-backdrop
        id="modal-tipo-exportar"
        title="Exportar Fluxo de Caixa"
      >
        <div class="grupo-exportar">
          <h4>Escolha uma opção:</h4>
          <el-radio v-model="tipoExportar" label="1" border>
            <i class="fas fa-file-export g-icon"></i>
            <div class="g-right">
              <p class="g-title"><b>Padrão</b></p>
              <p class="g-text"> Exportar em formato <b>DFC</b> </p>
            </div>
          </el-radio>
          <el-radio v-model="tipoExportar" label="2" border>
            <i class="fas fa-table g-icon"></i>
            <div class="g-right">
              <p class="g-title"><b>Tabela - Arquivo único</b></p>
              <p class="g-text"> Arquivo único (1 com todos os grupos) </p>
            </div>
          </el-radio>
          <el-radio v-model="tipoExportar" label="3" border>
            <i class="fas fa-table g-icon"></i>
            <div class="g-right">
              <p class="g-title"><b>Tabela - Todas as linhas</b></p>
              <p class="g-text"> Arquivo único (todas as linhas) </p>
            </div>
          </el-radio>
          <!-- <el-radio v-model="tipoExportar" label="3" border>
            <i class="fas fa-file-alt g-icon"></i>
            <div class="g-right">
              <p class="g-title"><b>Tabela - Arquivo único</b></p>
              <p class="g-text"> Arquivo único (1 com todos os grupos) </p>
            </div>
          </el-radio>
          <el-radio v-model="tipoExportar" label="4" border>
            <i class="fas fa-tasks g-icon"></i>
            <div class="g-right">
              <p class="g-title"><b>Tabela - Todas as linhas</b></p>
              <p class="g-text"> Arquivo único com linhas de cálculo </p>
            </div>
          </el-radio> -->
        </div>

        <template #modal-footer="{ hide }">
          <div class="float-right">
            <el-button size="small" @click="hide()">Fechar</el-button>
            <el-button type="primary" size="small" @click="exportar">Exportar</el-button>
          </div>
        </template>
      </b-modal>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ModalExportar',
    data () {
      return {
        tipoExportar: '1'
      }
    },
    methods: {
      exportar() {
        if(!this.$parent.isValidFluxoDeCaixa()) {
          this.$notify.error({
						title: 'Erro ao exportar',
						message: `Por favor, configure os filtros para exportar.`,
						position:'top-left'
					});
          return
        } 
        
        switch(this.tipoExportar)  {
          case '1': this.$parent.exportarFluxoCaixa(); break;
          case '2': this.$parent.requestGerarRelatorioTabela(this.$urls.FLUXO_CAIXA_EXPORTAR_TABELA); break;
          case '3': this.$parent.requestGerarRelatorioTabela(this.$urls.FLUXO_CAIXA_EXPORTAR_TABELA_TODAS_LINHAS); break;
        }
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .grupo-exportar {
    h4 { font-size:15px; }
    label.el-radio {
      width: 100%;
      padding: 0px 12px 19px;
      height: auto;
    }
    .el-radio.is-bordered+.el-radio.is-bordered {
      margin-left: 0;
    }
    .g-icon {
      border: 1px solid #ccc;
      height: 40px;
      width: 40px;
      text-align: center;
      line-height: 36px;
      border-radius: 6px;
      margin-right: 8px;
      margin-top: 15px;
    }
    .g-title {
      font-size: 15px;
    }
    .g-text {
      margin: 4px;
    }
    .g-right {
      display: inline-block;
      position: relative;
      top: 9px;
      left: 10px;
      p {
        margin:0;
      }
    }
  }
  
  </style>